module.exports = __webpack_public_path__ + "img/android-icon-48x48.c7b28c0.png";